import { useState } from "react";
import { toast } from "sonner";

import FormDialog from "@/components/reusables/FormDialog";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { OptionToast } from "@/constants/employees/employee.constants";
import { EmployeeOptionsType } from "@/interfaces/globals";
import { useUpdateEmployeeOptionsMutation } from "@/redux/api/employeeQuery";

type TProps = {
  type: EmployeeOptionsType;
  isOpen: boolean;
  toggleModal: () => void;
};

const AddOption: React.FC<TProps> = ({ type, isOpen, toggleModal }) => {
  const [option, setOption] = useState<{
    name: string;
    for: EmployeeOptionsType;
  }>({
    name: "",
    for: type,
  });

  const [alterOptions, { isLoading }] = useUpdateEmployeeOptionsMutation();

  const handleSubmit = async (
    e: React.FormEvent<HTMLFormElement>,
  ): Promise<void> => {
    e.preventDefault();
    if (!option.name || option.name === "" || option.name.length < 2) {
      toast.error(OptionToast.NAME_REQUIRED);

      return;
    }

    const res = await alterOptions({
      method: "POST",
      data: option,
    });

    if (res?.data && "data" in res && "message" in res?.data) {
      toast.success(OptionToast.ADDED);
      setOption({ name: "", for: type });
      toggleModal();
    }
  };

  return (
    <FormDialog
      title={`Add Options`}
      isOpen={isOpen}
      toggleModal={() => toggleModal()}
    >
      <form onSubmit={handleSubmit}>
        <div className='grid gap-4 py-4'>
          <div className='space-y-2'>
            <Label htmlFor='filename' className='ml-2' required>
              Option Name
            </Label>
            <Input
              id='filename'
              className='col-span-2'
              onChange={(e) =>
                setOption(() => ({ for: type, name: e.target.value }))
              }
            />
          </div>
        </div>
        <DialogFooter>
          <Button type='submit' isLoading={isLoading}>
            Save changes
          </Button>
        </DialogFooter>
      </form>
    </FormDialog>
  );
};

export default AddOption;
